export default {
  data() {
    return {
    };
  },
  methods: {
    formatDateForData: function (date) {
      return date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2);
    },
    formatDateForUser: function (date) {
      let d = this.getSafeDate(date);
      return d.toLocaleString('default', { month: 'long' }) + ' ' + d.getDate() + ', ' + d.getFullYear();
    },
    getMonthName: function (date) {
      let d = this.getSafeDate(date);
      return d.toLocaleString('default', { month: 'long' });
    },
    getMonthYearForUser: function (date) {
      let d = this.getSafeDate(date);
      return d.toLocaleString('default', { month: 'long' }) + ' ' + d.getFullYear();
    },
    getSafeDate: function (date) {
      // Even though none of our dates have a time zone specified, JS will display this with the local offset, so we need to convert it here or we'll get the wrong value on the first day of the month
      let d = new Date(date);
      let offset = d.getTimezoneOffset() * 60000;
      return new Date(d.getTime() + offset);
    }
  }
}
